var _style, _path, _path2, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconZones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-zones_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-zones_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-zones_svg__st0",
    d: "M12 1C7.7 1 4.1 4.5 4.1 8.9V9.2c0 .3.1.8.2 1.5V11c.6 3 2.2 8.5 7 11.9l.6.4.6-.4c4.8-3.4 6.5-8.9 7-11.9v-.2-.1c.1-.7.2-1.2.2-1.5V8.9C19.9 4.5 16.3 1 12 1zm5.9 8c0 .2 0 .5-.1.9 0 .1 0 .3-.1.4v.2c-.5 2.6-1.8 7.2-5.7 10.2-3.8-3-5.2-7.6-5.7-10.2V10.2v-.3c0-.2 0-.4-.1-.5v-.2-.3-.1C6.2 5.6 8.8 3 12 3c3.2 0 5.9 2.6 5.9 5.8V9zM6.1 8.9c0 .1 0 0 0 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-zones_svg__st0",
    d: "M4.3 10.7c-.1-.5-.2-1-.2-1.5.1.3.1.8.2 1.5zM6.1 9s0-.1 0 0zM6.2 9.3V9c-.1 0 0 .2 0 .3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-zones_svg__st0",
    d: "M19.9 9.2c0 .5-.1 1-.2 1.5.1-.7.1-1.2.2-1.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-zones_svg__st0",
    d: "M12 12.3c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3c1.8 0 3.3 1.5 3.3 3.3s-1.5 3.3-3.3 3.3zm0-5c-.9 0-1.7.8-1.7 1.7s.8 1.7 1.7 1.7 1.7-.8 1.7-1.7-.8-1.7-1.7-1.7z"
  }))));
}

export default SvgIconZones;